
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function LicenceClient({licence, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{licence?.libtypelicence}</td>
            <td>{licence?.datecrea.slice(0, 10)}</td>
            {/* <td><ReactTimeAgo date={Date.parse(licence?.datecrea)} timeStyle="facebook" /></td> */}
            <td>{licence?.datefin ? <ReactTimeAgo date={Date.parse(licence?.datefin)} timeStyle="facebook" /> : "Aucune"}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (licence?.etat === 1) ? 'badge-success' :
                        (licence?.etat === 2) ? 'badge-warning' : 
                        (licence?.etat === 3) ? 'badge-danger' : 
                        ''
                        }`
                    }>
                        {
                            (licence?.etat === 1) ? 'Active' : 
                            (licence?.etat === 2) ? 'Suspendu' : 
                            (licence?.etat === 3) ? 'Expiré' : 
                            ''
                        }
                </div>
            </td>
            <td><ReactTimeAgo date={Date.parse(licence?.datecrea)} timeStyle="facebook" /></td>
            <td className="text-center">
                <Link to={`/licence/${licence?.code}`} data-toggle="tooltip" title="consulter la licence" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}